import React from 'react';
import aboutusImage from '../assets/aboutusimage.jpg';
import './Aboutus.css';
import YoutubeVideoimage from '../assets/youtubevdoimg.PNG';
import Image from '../assets/image.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faSquareInstagram } from '@fortawesome/free-brands-svg-icons';
import { faFacebook } from "@fortawesome/free-brands-svg-icons";

const Aboutus = () => {
  return (
    <>
    <div>
    <div style={{ position: 'relative' }}>
  <img
    src={aboutusImage}
    className="abtbgimg" 
    alt='Aboutus'
    style={{
      width: '100%',
      height: '90vh',
      objectFit: 'cover',
      filter: 'blur(1px)', // Apply blur effect
    }}
  />
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Light black shade with 30% opacity
      pointerEvents: 'none', // Ensures the overlay doesn't interfere with interactions
    }}
  />
</div>

        <div className=' lorem'>MSilk Spa</div>
        <div className='aboutuse d-flex justify-content-center w-75' >
        At MSilk Spa, we specialize increating stunning nail designs, from coveted Russian Manicures to intricatenail art and
        long-lasting gel finishes. Beyond nails, we offer waxing and hair care treatments to complete your self care routine. Every visit is designed to leave you feeling pampered and polished.
        </div>
    </div>

    <div className="container p-5 m-5">
  <div className="row align-items-center">
    {/* Left Content */}
    <div className="col-12 col-md-6 content-padding">
      {/* <h1 className="text-start aboutushead">About Us</h1> */}
      <h3 className="text-start ourspa" style={{ fontWeight: "bold" }}>Our Spa Procedures</h3>
      <p className="text-start ourspacontent" style={{ fontSize: "10px", maxWidth: "300px" }}>
      Lorem ipsum dolor curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. Curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. 
      Lorem ipsum dolor curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. Curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. 
      Lorem ipsum dolor curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. Curabitur sed tellus ipsum. Sed tristique ut orci ut gravida.
      </p>
      <p className="text-start ourspacontent pt-2" style={{ fontSize: "12px", maxWidth: "300px" }}>
      Curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. Lorem ipsum dolor curabitur sed tellus ipsum. Sed tristique ut orci ut gravida.
       Curabitur sed tellus ipsum. Sed tristique ut orci ut gravida.
      </p>
    </div>
    
    {/* Right Image */}
    <div className="col-12 col-md-6 spaprocedures">
      <img src={YoutubeVideoimage} alt="Nail Services" style={{ width: "100%",height:'350px', borderRadius: "0px" }} />
    </div>
  </div>
</div>




    <div className='pb-5  professional' >
    <h3 className="text-center ourteam" style={{fontWeight:'bold'}}>Our Team</h3>
    <h6 className="text-center pt-2 meet" >Meet our Professionals</h6>
    <div className="d-flex col-md-12 justify-content-around flex-wrap  text-center" style={{background:'white'}}>
            <div className="cad p-0 border-0  col-sm-4" style={{ width: "300px" }}>
                <img className="card-img-top" src={Image} alt="Card" style={{ width: "100%" }} />
                <div className="card-body bg-light" style={{background:'white'}}>
                <h4 className="card-title name">Marianna Holder</h4>
                <p className="card-text mb-0 role">Role</p>
                <div className='text-center icon'>      
                    <span ><FontAwesomeIcon icon={faFacebook} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareXTwitter} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareInstagram} style={{color:" #6B0606"}} /></span>
            </div>
                </div>
            </div>

            <div className="cad p-0 border-0 " style={{ width: "300px" }}>
                <img className="card-img-top" src={Image} alt="Card" style={{ width: "100%" }} />
                <div className="card-body bg-light">
                <h4 className="card-title name">Tiffany Anderson</h4>
                <p className="card-text mb-0 role">Role</p>
                <div className='text-center icon'>      
                    <span ><FontAwesomeIcon icon={faFacebook} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareXTwitter} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareInstagram} style={{color:" #6B0606"}} /></span>
            </div>
                </div>
            </div>


            <div className="cad p-0 border-0 " style={{ width: "300px" }}>
                <img className="card-img-top" src={Image} alt="Card" style={{ width: "100%" }} />
                <div className="card-body bg-light">
                <h4 className="card-title name">Brianna Fitzgerald</h4>
                <p className="card-text mb-0 role">Role</p>
                <div className='text-center icon'>      
                    <span ><FontAwesomeIcon icon={faFacebook} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareXTwitter} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareInstagram} style={{color:" #6B0606"}} /></span>
            </div>
                </div>
            </div>

    </div>


    <div className="d-flex col-md-12 justify-content-around flex-wrap  text-center pt-5 pb-3">
            <div className="cad p-0 border-0  col-sm-4" style={{ width: "300px" }}>
                <img className="card-img-top" src={Image} alt="Card" style={{ width: "100%" }} />
                <div className="card-body bg-light">
                <h4 className="card-title name">Jaqueline Colon</h4>
                <p className="card-text mb-0 role">Role</p>
                <div className='text-center icon'>      
                    <span ><FontAwesomeIcon icon={faFacebook} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareXTwitter} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareInstagram} style={{color:" #6B0606"}} /></span>
            </div>
                </div>
            </div>

            <div className="cad p-0 border-0 " style={{ width: "300px" }}>
                <img className="card-img-top" src={Image} alt="Card" style={{ width: "100%" }} />
                <div className="card-body bg-light">
                <h4 className="card-title name">Wanda Cummerata</h4>
                <p className="card-text mb-0 role">Role</p>
                <div className='text-center icon'>      
                    <span ><FontAwesomeIcon icon={faFacebook} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareXTwitter} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareInstagram} style={{color:" #6B0606"}} /></span>
            </div>
                </div>
            </div>


            <div className="cad p-0 border-0 " style={{ width: "300px" }}>
                <img className="card-img-top" src={Image} alt="Card" style={{ width: "100%" }} />
                <div className="card-body bg-light">
                <h4 className="card-title name">Cameron Banks</h4>
                <p className="card-text mb-0 role">Role</p>
                <div className='text-center icon'>      
                    <span ><FontAwesomeIcon icon={faFacebook} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareXTwitter} style={{color:" #6B0606"}} /></span>
                <span className='ps-2'><FontAwesomeIcon icon={faSquareInstagram} style={{color:" #6B0606"}} /></span>
            </div>
                </div>
            </div>

    </div>

    </div>
    
    </>
  )
}
export default Aboutus;